import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { AppButton } from "../../../../../../shared/components/AppButton";
import { PlusIcon } from "../../../../../../shared/icons/PlusIcon";
import { useCaseCommentsBlock } from "../../../../hook/use-case-comments-block";
import { selectCaseComments } from "../../../../redux/selectors";
import { CaseCommentBlock } from "./CaseCommentBlock";
import { CreateCaseCommentBlock } from "./CreateCaseCommentBlock";
import styles from "./styles.module.css";

interface Props {
  scrollRef: React.RefObject<HTMLDivElement>;
}

export const CaseComments = ({ scrollRef }: Props) => {
  const caseComments = useAppSelector(selectCaseComments);
  const {
    comments,
    isCommentBlockOpen,
    handleChangeBlockOpen,
    addCommentBlock,
    deleteCaseCommentBlock,
    saveComment,
    changeCommentValue,
    handleDeleteComment,
  } = useCaseCommentsBlock();
  return (
    <div className={styles["comments-container"]}>
      <div
        onClick={handleChangeBlockOpen}
        className={styles["comments-container-header"]}
      >
        <h2>Комментарии</h2>
        <AppButton
          buttonType={"text"}
          onClick={(e) => {
            e.stopPropagation();
            addCommentBlock();
            setTimeout(() => {
              scrollRef.current?.scrollTo({
                top: scrollRef.current.scrollHeight,
                behavior: "smooth",
              });
            }, 0);
          }}
          icon={<PlusIcon />}
          className={styles["add-comment-btn"]}
        >
          Добавить комментарий
        </AppButton>
      </div>
      {isCommentBlockOpen && (
        <>
          {caseComments.map((comment) => (
            <CaseCommentBlock
              key={comment.id}
              comment={comment}
              handleDeleteComment={handleDeleteComment}
            />
          ))}
          {comments.map((comment, index) => (
            <CreateCaseCommentBlock
              key={`temporary-comment-${index + 1}`}
              createCaseBlock={comment}
              handleChangeCommentField={changeCommentValue}
              handleDeleteCommentBlock={deleteCaseCommentBlock}
              handleSaveComment={saveComment}
            />
          ))}
        </>
      )}
    </div>
  );
};
